"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_jss_1 = require("react-jss");
var Typography_1 = require("../Typography");
var styles_1 = __importDefault(require("./styles"));
var classnames_1 = __importDefault(require("classnames"));
var useStyles = (0, react_jss_1.createUseStyles)(styles_1.default);
// eslint-disable-next-line no-redeclare
var RadioButton = function (_a) {
    var checked = _a.checked, className = _a.className, disabled = _a.disabled, helpText = _a.helpText, label = _a.label, onChange = _a.onChange, name = _a.name, value = _a.value, error = _a.error, inputProps = __rest(_a, ["checked", "className", "disabled", "helpText", "label", "onChange", "name", "value", "error"]);
    var classes = useStyles();
    var classname = (0, classnames_1.default)(classes.root, className);
    return (react_1.default.createElement("label", { className: classname },
        react_1.default.createElement("input", __assign({ type: "radio", className: (0, classnames_1.default)(classes.input, error && !disabled && classes.error), value: value, checked: checked, "aria-checked": checked, name: name, disabled: disabled, onChange: onChange }, inputProps)),
        react_1.default.createElement("span", { className: classes.labelText },
            react_1.default.createElement(Typography_1.UtilityText, { size: "medium" }, label),
            helpText && (react_1.default.createElement(Typography_1.UtilityText, { color: "secondary", size: "xsmall" }, helpText)))));
};
exports.default = RadioButton;
